<script setup lang="ts">
import { NodeViewContent, nodeViewProps, NodeViewWrapper } from "@tiptap/vue-3";
import { MailMjmlColumn, MailMjmlSection } from "#components";
import type { SignatureBlock } from "~/types/MailBlocks";

const store = useMailStore();
const props = defineProps(nodeViewProps);

const block = computed({
    get: () => useCloneDeep(store.getBlockById(props.node.attrs.id).block?.attrs ?? {}),
    set: (value) => props.updateAttributes(value),
});
</script>

<template>
    <NodeViewWrapper class="signature" @click.stop="store.focusedJsonId = node.attrs.id">
        <MailMjmlSection :style="{
            display:
                node.attrs.variant === '2-column-image'
                    ? undefined
                    : 'none',
        }" :css-class="node.attrs.identifier">
            <MailMjmlColumn :padding-top="node.attrs.marginTop" :padding-bottom="node.attrs.marginBottom" width="25%"
                :contenteditable="false">
                <MailMjmlImage :src="store.fieldCollection.replaceContent(node.attrs.src)" :alt="node.attrs.alt"
                    border-radius="100%" width="100px" height="100px" align="left"
                    @click.stop="store.focusedJsonId = node.attrs.id">
                    <MailBlockSettingBaseImage v-if="!block.src" :fields="store.builderFields"
                        button-class="w-[100px] h-[100px] justify-center items-center flex-col" :model-value="block.src"
                        @update:model-value="block = { ...block, src: $event }" />
                </MailMjmlImage>
            </MailMjmlColumn>
            <MailMjmlColumn width="75%" :padding-top="node.attrs.marginTop" :padding-bottom="node.attrs.marginBottom">
                <NodeViewContent />
            </MailMjmlColumn>
        </MailMjmlSection>
    </NodeViewWrapper>
</template>

<style scoped></style>
